import { defineMessages } from 'react-intl';

export default defineMessages({
  reservations: {
    id: 'class-list.reservations',
    defaultMessage: 'Reservations',
  },
  enabled: {
    id: 'class-list.enabled',
    defaultMessage: 'Enabled',
  },
  disabled: {
    id: 'class-list.disabled',
    defaultMessage: 'Disabled',
  },
  contractDescription: {
    id: 'classes-list.contract-description',
    defaultMessage:
      'Please only enable services that are approved to be offered on ClassPass. A list of approved services can be found in the <a>Help Center</a>.',
  },
  name: {
    id: 'class-list.name',
    defaultMessage: 'Name',
  },
  bookable: {
    id: 'class-list.bookable',
    defaultMessage: 'Bookable on ClassPass',
  },
  payoutLabel: {
    id: 'class-list.payout-label',
    defaultMessage: 'Payout <icon></icon>',
  },
  payoutTooltip: {
    id: 'class-list.payout-tooltip',
    defaultMessage:
      'Your payout is calculated based on your provided price for this service. For service tax clarifications, please see <link>here</link>.',
  },
  pendingReview: {
    id: 'class-list.pending-review',
    defaultMessage: 'Pending review',
  },
  pendingReviewTooltip: {
    id: 'class-list.pending-review-tooltip',
    defaultMessage: 'Pricing is under review',
  },
  actionRequired: {
    id: 'class-list.action-required',
    defaultMessage: 'Action required',
  },
  rejectedProofUntrustedTooltip: {
    id: 'class-list.rejected-proof-untrusted-tooltip',
    defaultMessage: 'Verification failed — proof not accepted',
  },
  rejectedPartnerDeclinedTooltip: {
    id: 'class-list.rejected-partner-declined-tooltip',
    defaultMessage: 'Pricing submission was declined',
  },
  rejectedGenreTooltip: {
    id: 'class-list.rejected-genre-tooltip',
    defaultMessage: 'Genre not approved for ClassPass',
  },
  rejectedDisagreementTooltip: {
    id: 'class-list.rejected-disagreement-tooltip',
    defaultMessage: 'Disagreement on pricing terms',
  },
});
